import axios from '../external/Axios';
import Url from '../constants/Url';

class RedeemApi {
    redeem(data) {
        return axios.post(Url().CODE.REDEEM, data)
            .then((response) => {
                return response.data.data;
            }).catch((ex) => {
                console.info('Failed to redeem:', ex.message);
                throw ex;
            });
    }
}

export default new RedeemApi();
